import { authorizedApiClient } from "./config";
import type { IntegrationAppFieldDefinition, IntegrationAppCreateFieldInput } from "./integrationAppEndpoint.interface";

export const generateIntegrationAppToken = async ({
  workspace_id,
  isMemberLevel = false,
}: { workspace_id: string; isMemberLevel?: boolean }) => {
  const url = `/integration-app/${workspace_id}/generate-token?member_level=${isMemberLevel}`;
  return authorizedApiClient.post(url, {
    workspace_id,
  });
};

export const verifyIntegrationAppToken = async ({
  token,
}: { token: string }) => authorizedApiClient.post(`/integration-app/verify-token`, {
  token,
});

export const testIntegrationAppConnection = async () => authorizedApiClient.get(`/integration-app/test-connection`);

// Field definition endpoints
export const getWorkspaceFields = async ({
  workspace_id
}: { workspace_id: string }) => authorizedApiClient.get<IntegrationAppFieldDefinition[]>(`/workspaces/${workspace_id}/fields`);

export const getObjectFields = async ({
  workspace_id,
  objectId
}: { workspace_id: string; objectId: string }) => authorizedApiClient.get<IntegrationAppFieldDefinition[]>(`/workspaces/${workspace_id}/objects/${objectId}/fields`);

export const createBulkFields = async ({
  workspace_id,
  objectId,
  fields
}: {
  workspace_id: string;
  objectId: string;
  fields: IntegrationAppCreateFieldInput[];
}) => authorizedApiClient.post(`/workspace/${workspace_id}/objects/${objectId}/fields/bulk`, fields);
